import Dashboard from 'views/Dashboard/Dashboard';
import TableList from 'views/TableList/TableList';
import Icons from 'views/Icons/Icons';
import Payment from 'views/Payment/Payment';
import Login from 'views/Login/Login';

const appRoutes = [
    {path: "/dashboard", name: "Dashboard", icon: "pe-7s-graph", component: Dashboard, signedIn: true},
    {path: "/table", name: "Submissions", icon: "pe-7s-note2", component: TableList, signedIn: true},
    {path: "/icons", name: "Icons", icon: "pe-7s-science", component: Icons, signedIn: false},
    // { upgrade: true, path: "/upgrade", name: "Upgrade to PRO", icon: "pe-7s-rocket", component: Upgrade },
    {path: "/payment", name: "Payment", icon: "pe-7s-cash", component: Payment, signedIn: false},
    {path: "/login", name: "Login", icon: "pe-7s-users", component: Login, signedIn: false},
    {redirect: true, path: "/", to: "/login", name: "Login"},
];

export default appRoutes;



// WEBPACK FOOTER //
// ./src/routes/app.jsx